import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Vue.config.productionTip = false;

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import LazyTransition from "vue-lazy-transition";
import VueScrollTo from "vue-scrollto";
import VueAnalytics from "vue-analytics";

import router from "./router";
import App from "./App.vue";

import Divider from "./components/Divider.vue";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(LazyTransition);
Vue.use(VueScrollTo);
Vue.use(VueAnalytics, {
  id: "UA-202841995-1",
  router,
});

Vue.component('Divider', Divider);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
